const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const {
    connect
} = require('react-redux');
// @ actions
const reimburseInvestmentActions = require('actions/reimburseInvestment');
// @constants
const {
    NOT_ALLOWED_WEALTH_FUNDS_SELL_SHOW_COST_COUNTRIES,
    WEALTH_FUNDS_PARTIAL_REIMBURSEMENT
} = require('constants/flagBasedFeatures');
// @ components
const ReimburseInvestmentStep2ContentWithCosts = require(
    'components/hireInvestmentFunds/reimburseInvestmentStep2ContentWithCosts/reimburseInvestmentStep2ContentWithCosts')
const ReimburseInvestmentStep2Content = require('components/hireInvestmentFunds/reimburseInvestmentStep2Content/reimburseInvestmentStep2Content');
const {
    FIRST_STEP
} = require('constants/index');
class ReimburseInvestmentStep2 extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const {
            getReimburseExAntDetails,
            immReimburseInvestment,
            immFlagBasedFeatures,
            fundId,
            contractNumber
        } = this.props;
        const reimburseFund = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'reimburseFund']).toJS();
        this.props.getInterveners(reimburseFund);
        if( immFlagBasedFeatures.get(NOT_ALLOWED_WEALTH_FUNDS_SELL_SHOW_COST_COUNTRIES)) {
            getReimburseExAntDetails(fundId, contractNumber)
        }
    }
    render() {
        const {
            immReimburseInvestment,
            immFlagBasedFeatures,
            immMyInvestments,
            fundId,
            contractNumber,
        } = this.props;
        const productNumber = fundId.substring(0, 3);
        const immFund = immMyInvestments.getIn(['products', 'funds', 'stocks']).find(fund =>
            fund.get('producto') === productNumber &&
            fund.get('numerodecontrato') === contractNumber
        );
        const reimburseFund = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'reimburseFund']).toJS();
        const codbban = reimburseFund.codbban;
        const currencyFund = reimburseFund.currencyFund;
        const ffFundsPartialReimbursement = immFlagBasedFeatures.get(WEALTH_FUNDS_PARTIAL_REIMBURSEMENT);
        const customCategoryId2 = immReimburseInvestment.getIn(['steps', 0, 'reimburseInvestment', 'customCategoryId2']);
        const amount =
          ffFundsPartialReimbursement && customCategoryId2 === '2'
            ? immReimburseInvestment.getIn(['steps', FIRST_STEP, 'participationAmount'])
            : immReimburseInvestment.getIn(['steps', FIRST_STEP, 'amount']);
        const operationParams = {
            originAccount: codbban,
            ammount: amount,
            currency: currencyFund
        };
        const flag = immFlagBasedFeatures.get(NOT_ALLOWED_WEALTH_FUNDS_SELL_SHOW_COST_COUNTRIES);
        const content = flag ? (
            <ReimburseInvestmentStep2ContentWithCosts
                operationParams={operationParams}
                immReimburseInvestment={immReimburseInvestment}
                immFund={immFund}
            />
        ) : (
            <ReimburseInvestmentStep2Content
                operationParams={operationParams}
                immReimburseInvestment={immReimburseInvestment}
                immFlagBasedFeatures={immFlagBasedFeatures}
            />
        );
        return content;
    }
}
ReimburseInvestmentStep2.propTypes = {
    getReimburseExAntDetails: PropTypes.func.isRequired,
    getInterveners: PropTypes.func.isRequired,
    immReimburseInvestment: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    fundId: PropTypes.string.isRequired,
    contractNumber: PropTypes.string.isRequired
};
module.exports.constructor = ReimburseInvestmentStep2;
module.exports.ReimburseInvestmentStep2 = connect(state => ({
    immMyInvestments: state.brokerMyInvestments,
    immFlagBasedFeatures: state.flagBasedFeatures,
}), {
    getInterveners: reimburseInvestmentActions.getInterveners
})(ReimburseInvestmentStep2);
